export const mediaBaseDomain = "https://media.wavescdn.com";
export const queryStringSafeChars =/[^0-9a-zA-Z-+/ ]+/g;

